/**
 * Meridian HITL approval policy — public surface.
 *
 * One function per surface, and they are the ONLY things that decide whether a tool call prompts.
 * See `./tool-approval-policy` for why per-tool `needsApproval` stops being consulted the moment
 * these are wired.
 */

export {
  agentToolApprovalPolicy,
  streamToolApprovalPolicy,
  type ToolApprovalDecisionInput,
  type ToolApprovalPolicy,
} from './tool-approval-policy.js';
